<template>
    <div class="home_container">
      <div :class="isMobileS?'banner':'pc-banner'">
        <img :src="isMobileS?banner:pcBanner" alt=""/>
      </div>
      <div :class="isMobileS?'content h5-content':'content'">
        <Notice :isMobileS="isMobileS" v-if="isShow"  @goClick="goClick" />
        <AddForm :isMobileS="isMobileS" v-else-if="!isShow" @onCancel="onCancel"/>
      </div>
      <div :class="isMobileS?'h5-bg':'pc-bg'" v-if="isShow">
        <img :src="isMobileS?h5Bg:pcBg" alt=""/>
      </div>
    </div>
  </template>
<script>
import banner from '@/assets/images/cbs/banner.png'
import pcBanner from '@/assets/images/cbs/pc-banner.png'
import h5Bg from '@/assets/images/cbs/h5-bg.png'
import pcBg from '@/assets/images/cbs/pc-bg.png'
import Notice from '@/components/Notice.vue'
import AddForm from '@/components/AddForm.vue'
import isMobile from 'ismobilejs'
import wxShare from '@/utils/wxshare'
import $ from 'jquery'
export default {
  name: 'index',
  data () {
    return {
      data: { },
      banner,
      h5Bg,
      pcBg,
      pcBanner,
      isShow: true,
      isMobileS: isMobile(window.navigator.userAgent).any
    }
  },
  components: {
    Notice,
    AddForm
  },
  created () {
  },
  mounted () {
    this.$nextTick(() => {
      $('body').css('background', '#F3F2FF')
      wxShare({
        title: '“青年工匠说”主题微视频征集展示活动',
        desc: '快来参与，展现新时代青年工匠的风采！',
        imgUrl: 'https://cdn-app.people.cn/static/img/youngCraftsmenShareLogo.png'
      }, this)
      document.title = '“青年工匠说”主题微视频征集展示活动'
    })
  },
  updated () {
    // console.log('dddddddddd')
    // wxShare({
    //   title: '云顶长白雪域秘境摄影作品征集',
    //   desc: '发现身边美 邂逅长白山',
    //   imgUrl: 'https://cdn2-app.people.cn/static/shareLogo.png'
    // }, this)
    // document.title = '云顶长白雪域秘境摄影作品征集'
    window.addEventListener('resize', function () {
      this.isMobileS = isMobile(window.navigator.userAgent).any
      console.log(this.isMobileS, 'this.isMobileS')
    })
  },
  methods: {
    onCancel (data) {
      console.log(data, 'data')
      this.isShow = data
      console.log(this.isShow, 'isShow')
    },
    goClick (istrue) {
      this.isShow = istrue
    }
  }
}
</script>
  <style scoped lang="less">
  body{
    background: #F3F2FF;
  }
  .show{
    display: block;
  }
  .hide{
    display: none;
  }
  .home_container {
    background: #F3F2FF;
    height: 100vh;
    max-width: 1200px;
    margin:0 auto;
  }
  .banner {
    // height: 211px;
    overflow: hidden;
    img{
      width: 100%;
      // height: 100%;
    }
  }
  .pc-banner{
    // max-height:466px;
  }
  .content{
    padding:15px 0;
  }
  .h5-content{
    padding:15px !important;
  }
  .h5-bg{
    position: relative;
    bottom: 50px;
  }
  .pc-bg{
    position: relative;
    width: 41%;
    bottom: 130px;
  }
  </style>
